import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import ReCAPTCHA from "react-google-recaptcha";

import PROMO_A from "../../../assets/images/promo-a.png";
import PROMO_New from "../../../assets/images/promo-a-new.png";
import PROMO_B from "../../../assets/images/promo-b.png";
import PROMO_C from "../../../assets/images/promo-c.png";

import { checkLogin } from "../../../config/client_api_calls";

import {
  COMPANY_NAME,
  LOGO,
  THEME_COLOR,
  APP_URL,
  APP_LIVE_URL,
  FOOTER_SIGNATURE,
} from "../../../config/config";

import { ValidateEmail, axiosConfig } from "../../../config/utility";
import { tableLoaderSimple } from "../../../components/ContentLoaders/table_loader_simple";
import helpherClass from "../../../config/helperClass";
import { GoogleLogin } from "@react-oauth/google";
import localization from "../../../localization/enUS";
import { jwtDecode } from "jwt-decode";

const auth = new helpherClass();
const clientLogs = [];
export const logEvent = (event, data = {}) => {
  const timestamp = new Date().toISOString();
  const clientId = localStorage.getItem("reseller_url") || "unknown-client";

  let logLine = `[${timestamp}] ${event}`;
  const keys = Object.keys(data);
  if (keys.length > 0) {
    const details = keys.map((k) => `${k}: ${data[k]}`).join(" | ");
    logLine += ` → ${details}`;
  }

  
  clientLogs.push(logLine);
  localStorage.setItem("clientLogs", JSON.stringify(clientLogs));

  // Send to backend (clientId included)
  axios
    .post(
      process.env.REACT_APP_API_URL + "clients/log_event",
      JSON.stringify({ timestamp, event, data, clientId }),
      axiosConfig
    )
    .catch((err) => {
      console.error("LogEvent send failed:", err.message);
    });
};

const waitFor = (checkFn, callback, timeout = 5000, interval = 200) => {
  const start = Date.now();
  const timer = setInterval(() => {
    if (checkFn()) {
      clearInterval(timer);
      callback(true);
    } else if (Date.now() - start > timeout) {
      clearInterval(timer);
      callback(false);
    }
  }, interval);
  return timer; // Return timer ID for cleanup
};

export default class Login extends Component {
  constructor() {
    super();
    this.state = {
      errorEmail: "",
      errorPass: "",
      email: "",
      password: "",
      errorMessage: "",
      disabled: false,
      loader: "",
      successMessage: "",
      resellerData: [],
      tableLoader: true,
      tableLoaderSimple: true,
      res_accountno: "",
      res_url: "",
      res_hash: "",
      is_agent_selected: true,
      res_title: "",
      pageError: "",
      passwordShown: false,
      url_type: "Simple",
      signup_hash: "",
      isLogoutAction: false,
      appVersion: "",
    };
    this.site_key = process.env.REACT_APP_CAPTCHA_SITE_KEY;
    this.captcha_token = null;
    this._isMounted = false;
    this.timers = [];
  }

  async componentDidMount() {
    // Fetch version from version.json
    try {
      const versionResponse = await fetch(`/version.json?ts=${Date.now()}`);
      const versionData = await versionResponse.json();
      if (versionData.version) {
        this.setState({ appVersion: versionData.version });
      }
    } catch (error) {
      this.setState({ appVersion: "Version info is temporarily unavailable" });
    }

    this._isMounted = true;
    logEvent("PAGE_LOAD", { url: window.location.href });

    const urlParams = new URLSearchParams(this.props.location.search);
    let reseller_url = this.props.match.params.reseller_url;
    const action = urlParams.get("action");

    if (action === "logout") {
      logEvent("LOGOUT_ACTION");
      // console.log(
      //   "🔒 Logout action detected. Initiating secure client logout..."
      // );
      auth.clientLogoutAction();
      return;
    }

    // --- WEBSITE / ORDER FLOW ---
    // When an unauthenticated visitor clicks "Order Now" on the marketing site they land
    // on the order page, and the client-area guard saves that path to
    // sessionStorage.redirectAfterLogin before sending them here. An immediate login
    // restores that path (below). But a brand-new account crosses an email-verification
    // round trip that loses sessionStorage, so persist the ordered service_id durably in
    // localStorage.pendingOrderRef here. It survives registration (register doesn't clear
    // it) and the email round trip, and is consumed right after verification so the new
    // client lands on the SalesOrder — same destination as the existing-account flow.
    try {
      const _pendingPath = sessionStorage.getItem("redirectAfterLogin") || "";
      const _orderMatch = _pendingPath.match(/EditSalesOrder\/[^/]+\/([^/?]+)/);
      if (_orderMatch && _orderMatch[1]) {
        localStorage.setItem(
          "pendingOrderRef",
          JSON.stringify({
            service_id: _orderMatch[1],
            product_quantity: "1",
            form_accountno: "",
            timestamp: Date.now(),
          })
        );
      }
    } catch (_e) {}
    // --- END ORDER FLOW ---

    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("authProvider");
    localStorage.removeItem("userSub");
    if (this._isMounted) {
      this.setState({
        tableLoaderSimple: true,
      });
    }

    let urlElements = window.location.href.split("/");

    // console.log("CUrrent URL: ", reseller_url);
    let host_url = urlElements[2];
    //if (reseller_url !== "") {
    //Errors
    //404 and no_reseller
    //404 and no_agent
    try {
      logEvent("API_CALL", {
        endpoint: "agents/check_reseller_login",
        reseller_url,
        host_url,
      });
      axios
        .post(
          process.env.REACT_APP_API_URL + "agents/check_reseller_login",
          JSON.stringify({
            reseller_url: reseller_url,
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            host_url: host_url,
          }),
          axiosConfig
        )
        .then((response) => {
          if (!this._isMounted) return; // Check if component is still mounted
          
          logEvent("API_RESPONSE", {
            endpoint: "agents/check_reseller_login",
            status: response.data.status,
            message: response.data.message,
          });
          // console.log("response.data start : ", response.data);
          if (
            response.data.status === 404 ||
            response.data.status === 422 ||
            response.data.errors !== ""
          ) {
            this.setState({
              errorMessage: "",
              successMessage: "",
              show_form: false,
              pageError:
                "Sorry we are unable to process your request. Please contact admin for more details.",
              tableLoaderSimple: false,
            });
          }

          if (
            response.data.status === 404 &&
            response.data.message === "no_reseller"
          ) {
            logEvent("NO_RESELLER_REDIRECT", {
              to: response.data.super_reseller_identifier,
            });
            window.location.replace(response.data.super_reseller_identifier);
            this.setState({
              pageError: "",
            });
            // this.setState({
            //   errorMessage: "",
            //   pageError:
            //     "Reseller does not exists. Please contact support or try again with correct URL.",
            //   successMessage: "",
            //   show_form: false,
            //   tableLoaderSimple: false,
            // });
          } else if (response.data.status === 403) {
            logEvent("API_FORBIDDEN", {});
            this.setState({
              errorMessage: "There is some error.",
              successMessage: "",
              show_form: false,
              tableLoaderSimple: false,
              pageError: "",
            });
          } else if (
            response.data.status === 200 &&
            response.data.message === "success"
          ) {
            logEvent("API_SUCCESS", { reseller: response.data.reseller_url });
            // console.log("response.data.url_type: ", response.data.url_type);
            Cookies.set(
              "residentifier__",
              CryptoJS.AES.encrypt(
                response.data.reseller_url,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "resacct__",
              CryptoJS.AES.encrypt(
                response.data.res_accountno,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "restitle__",
              CryptoJS.AES.encrypt(
                response.data.reseller_title,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "reslogo__",
              CryptoJS.AES.encrypt(
                response.data.reseller_logo,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "ressig__",
              CryptoJS.AES.encrypt(
                response.data.reseller_signature,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "urltype__",
              CryptoJS.AES.encrypt(
                response.data.url_type,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            Cookies.set(
              "client_country__",
              CryptoJS.AES.encrypt(
                response.data.country,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );

            this.setState({
              errorMessage: "",
              res_accountno: response.data.res_accountno,
              res_title: response.data.reseller_title,
              resellerData: response.data,
              tableLoader: false,
              show_form: true,
              pageError: "",
              res_url: reseller_url,
              res_hash: response.data.reseller_hash,
              tableLoaderSimple: false,
              url_type: response.data.url_type,
              signup_hash: response.data.signup_hash,
            });
          }
        });
    } catch (error) {
      logEvent("API_ERROR", {
        endpoint: "agents/check_reseller_login",
        error: error.message,
      });
      if (this._isMounted) {
        this.setState({
          errorMessage: "",
          successMessage: "",
          show_form: false,
          tableLoaderSimple: false,
          pageError:
            "Please enter the valid URL or contact admin for more details",
        });
      }
      // console.log("catch : ", error);
    }
    // --- ReCAPTCHA availability check ---
    const recaptchaTimer = waitFor(
      () => window.grecaptcha,
      (loaded) => {
        if (!this._isMounted) return;
        if (loaded) {
          logEvent("RECAPTCHA_LOADED");
        } else {
          logEvent("RECAPTCHA_TIMEOUT", { reason: "Not available within 5s" });
        }
      }
    );
    this.timers.push(recaptchaTimer);

    // --- Google API availability check ---
    const googleApiTimer = waitFor(
      () => window.google && window.google.accounts,
      (loaded) => {
        if (!this._isMounted) return;
        if (loaded) {
          logEvent("GOOGLE_API_LOADED");
        } else {
          logEvent("GOOGLE_API_TIMEOUT", { reason: "Not available within 5s" });
        }
      }
    );
    this.timers.push(googleApiTimer);
  }

  componentWillUnmount() {
    this._isMounted = false;
    // Clear all timers
    this.timers.forEach(timer => clearInterval(timer));
    this.timers = [];
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleCaptchaChange = (value) => {
    this.captcha_token = value;
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  formSubmitClient = async (e) => {
    e.preventDefault();
    let { email, password } = this.state;

    if (email === "") {
      return this.setState({
        errorEmail: "error",
        errorMessage: "Email is required.",
      });
    } else if (ValidateEmail(email) === false) {
      return this.setState({
        errorEmail: "error",
        errorMessage: "Invalid email format.",
      });
    } else if (password === "") {
      return this.setState({
        errorPass: "error",
        errorEmail: "",
        errorMessage: "Password is required.",
      });
    } else if (this.captcha_token === "" || this.captcha_token === null) {
      return this.setState({
        errorPass: "",
        errorEmail: "",
        errorMessage: "Invalid captcha, please retry.",
      });
    } else {
      this.setState({
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        disabled: true,
        loader: "show",
      });

      try {
        const response = await checkLogin(email, password);
        if (!this._isMounted) return; // Check if component is still mounted
        
        //console.log("clientlogin", response.data);
        if (
          response.data.status === 404 &&
          response.data.message === "invalid_credentials"
        ) {
          this.setState({
            errorMessage: response.data.errors,
            disabled: false,
          });
        } else if (
          response.data.status === 404 ||
          response.data.status === 422 ||
          response.data.errors !== ""
        ) {
          this.setState({
            errorMessage: response.data.errors,
            disabled: false,
          });
        }

        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          this.setState({
            successMessage: "Please wait, redirecting you to the dashboard.",
            errorMessage: "",
          });

          const decodedToken = jwtDecode(response.data.token);
          const tokenExpiryTime = decodedToken.exp * 1000;
          const currentTime = new Date().getTime();

          Cookies.set(
            "client_tkn__",
            CryptoJS.AES.encrypt(
              response.data.token,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_acn__",
            CryptoJS.AES.encrypt(
              response.data.accountno,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_eml__",
            CryptoJS.AES.encrypt(
              response.data.email,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_comp_nme__",
            CryptoJS.AES.encrypt(
              response.data.comp_name,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_user_type__",
            CryptoJS.AES.encrypt(
              response.data.user_type,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_parent_accountno__",
            CryptoJS.AES.encrypt(
              response.data.parent_accountno,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_name__",
            CryptoJS.AES.encrypt(
              response.data.name,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_phone__",
            CryptoJS.AES.encrypt(
              response.data.phone,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_adress__",
            CryptoJS.AES.encrypt(
              response.data.address,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_title__",
            CryptoJS.AES.encrypt(
              response.data.title,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_domain_name__",
            CryptoJS.AES.encrypt(
              response.data.domain_name,
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_session_start__",
            CryptoJS.AES.encrypt(
              currentTime.toString(),
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          Cookies.set(
            "client_session_expiry__",
            CryptoJS.AES.encrypt(
              tokenExpiryTime.toString(),
              process.env.REACT_APP_SIGNATURE
            ).toString()
          );
          // Set a lightweight session indicator on the parent domain so the
          // sharelink frontend (on a sibling subdomain) can detect the active session.
          try {
            const _hostname = window.location.hostname;
            const _parts = _hostname.split('.');
            const _parentDomain = _parts.length >= 2 ? '.' + _parts.slice(-2).join('.') : _hostname;
            Cookies.set('client_sl_session__', '1', { domain: _parentDomain, expires: 1 });
          } catch (_e) {}
          localStorage.removeItem("activeMenusClient");
          localStorage.removeItem("activeSubmenuItemClient");

          const {
            voicePermissionAdmin,
            integrationInfo,
            parentIntegration,
            form_external_link,
            unsignedAgreements,
            user_type,
          } = response.data;

          const hasChildInt =
            Array.isArray(integrationInfo) && integrationInfo.length > 0;
          const hasParentInt =
            Array.isArray(parentIntegration) && parentIntegration.length > 0;

          const baseChecks =
            voicePermissionAdmin === "Yes" &&
            unsignedAgreements === "No" &&
            typeof form_external_link === "string" &&
            form_external_link.trim() !== "" &&
            hasChildInt;

          let isDirectSSO = false;
          if (baseChecks) {
            if (user_type === "Super") {
              isDirectSSO =
                integrationInfo[0].enable === "Yes" &&
                integrationInfo[0].direct_sso === "Yes";
            } else if (user_type === "Sub") {
              isDirectSSO =
                integrationInfo[0].enable === "Yes" &&
                integrationInfo[0].direct_sso === "Yes" &&
                hasParentInt &&
                parentIntegration[0].enable === "Yes" &&
                parentIntegration[0].direct_sso === "Yes";
            }
          }

          if (isDirectSSO) {
            const accountno = response.data.accountno;
            const email = response.data.email;
            const firstName = response.data.name;
            const compName = response.data.comp_name;
            const userType = response.data.user_type;
            const address = response.data.address || "";
            const title = response.data.title || "";
            const phone = response.data.phone || "";
            const country = response.data.country || "";
            const city = response.data.city || "";
            const zip = response.data.zip || "";
            const stateStr = response.data.state || "";
            const account_status =
              response.data.status === 200 ? "active" : "inactive";
            const status = account_status === "active" ? 1 : 0;
            const parent_accountno = response.data.parent_accountno || null;
            const serviceData = this.state.serviceArray_voicealerts || [];
            const return_url =
              APP_LIVE_URL + auth.getResellerRegToken() + "/client";

            const tokenData = {
              accountno,
              email,
              firstName,
              compName,
              userType,
              status,
              title,
              phone,
              address,
              city,
              state: stateStr,
              zip,
              country,
              password: "",
              serviceData,
              return_url,
              isDirectSSO,
              ...(userType === "Sub" ? { parent_accountno } : {}),
            };

            const tokenDataString = JSON.stringify(tokenData);
            const secretKey =
              process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
            const encryptedToken = this.pythonEncrypt(
              tokenDataString,
              secretKey
            );

            const finalUrl = form_external_link
              .replace(/\{{va_parameters\}}/g, encryptedToken)
              .replace(/\{{va_parameters_brand\}}/g, "");

            // Set cross-subdomain session indicator before leaving for SSO
            try {
              const _hostname = window.location.hostname;
              const _parts = _hostname.split('.');
              const _parentDomain = _parts.length >= 2 ? '.' + _parts.slice(-2).join('.') : _hostname;
              Cookies.set('client_sl_session__', '1', { domain: _parentDomain, expires: 1 });
            } catch (_e) {}

            window.location.replace(finalUrl);
            return;
          }

          setTimeout(function () {
            const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');
            sessionStorage.removeItem('redirectAfterLogin');
            let resolvedUrl = redirectAfterLogin && redirectAfterLogin !== '/' ? redirectAfterLogin : null;
            if (!resolvedUrl) {
              try {
                const pendingOrderRefStr = localStorage.getItem('pendingOrderRef');
                if (pendingOrderRefStr) {
                  const pendingOrderRef = JSON.parse(pendingOrderRefStr);
                  const TWO_HOURS = 7200000;
                  if (pendingOrderRef.service_id && (Date.now() - pendingOrderRef.timestamp) < TWO_HOURS) {
                    localStorage.removeItem('pendingOrderRef');
                    const resellerUrl = auth.getResellerRegToken();
                    const base = resellerUrl ? '/' + resellerUrl : '';
                    if (pendingOrderRef.form_accountno && pendingOrderRef.form_accountno !== "") {
                      resolvedUrl = `${base}/client/client_form_submit/${pendingOrderRef.form_accountno}/${crypto.randomUUID()}/${pendingOrderRef.service_id}`;
                    } else {
                      const qty = pendingOrderRef.product_quantity || '1';
                      const tempOrderNo = Math.floor(100000 + Math.random() * 900000);
                      resolvedUrl = `${base}/client/EditSalesOrder/${tempOrderNo}/${pendingOrderRef.service_id}/?qty=${qty}`;
                    }
                  } else {
                    localStorage.removeItem('pendingOrderRef');
                  }
                }
              } catch (e) {
                localStorage.removeItem('pendingOrderRef');
              }
            }
            if (!resolvedUrl) {
              resolvedUrl = auth.getResellerRegToken() + "/client/dashboard";
            }
            window.location.replace(resolvedUrl);
          }, 1000);
        }
      } catch (error) {
        // console.log("catch : ", error);
      }
    }
  };

  pythonEncrypt = (data, passphrase) => {
    const secretKey = CryptoJS.enc.Hex.parse(passphrase);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenate raw IV + ciphertext (in binary form)
    const rawIv = iv;
    const rawCiphertext = CryptoJS.enc.Base64.parse(encrypted.toString());

    const combined = rawIv.concat(rawCiphertext);

    const base64Encoded = CryptoJS.enc.Base64.stringify(combined);

    return base64Encoded
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  handleGoogleSuccess = (credentialResponse) => {
    if (
      process.env.REACT_APP_GOOGLE_OAUTH_CLIENTID ===
      credentialResponse.clientId
    ) {
      this.authLogin(credentialResponse.credential);
    }
  };

  authLogin = (authToken) => {
    let reseller_url = this.props.match.params.reseller_url;
    this.setState({
      disabled: true,
    });
    try {
      axios
        .post(
          process.env.REACT_APP_API_URL + "clients/login_Oauth",
          JSON.stringify({
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            authToken: authToken,
            reseller_url: reseller_url,
          }),
          axiosConfig
        )
        .then((response) => {
          if (!this._isMounted) return; // Check if component is still mounted
          
          // console.log("response: ", response);
          if (
            response.data.status === 200 &&
            response.data.message === "success" &&
            response.data.requestType === "user_register"
          ) {
            const userEmail = response.data.userEmail;
            const userName = response.data.userName;
            const userSub = response.data.userSub;
            const requestType = response.data.requestType;
            const signup_hash = response.data.signup_hash;
            const parentAccountInfo = response.data.parentAccountInfo;
            // console.log(
            //   "userEmail: ",
            //   userEmail,
            //   ", userName: ",
            //   userName,
            //   ", userSub: ",
            //   userSub,
            //   ", requestType: ",
            //   requestType
            // );
            localStorage.setItem("userEmail", userEmail);
            localStorage.setItem("userName", userName);
            localStorage.setItem("userSub", userSub);
            localStorage.setItem("authProvider", "google");
            if (parentAccountInfo && parentAccountInfo !== null) {
              localStorage.setItem("parentAccountInfo", JSON.stringify(parentAccountInfo));
            }
            this.setState({
              successMessage:
                "Please wait, while we set up your account. You will shortly be redirected to complete the setup process.",
              errorMessage: "",
            });
            setTimeout(() => {
              const redirectUrl = `client/register/${signup_hash}`;
              window.location.replace(redirectUrl);
            }, 2000);
          } else if (
            response.data.status === 200 &&
            response.data.message === "success" &&
            response.data.requestType === "user_login"
          ) {
            this.setState({
              successMessage: "Please wait, redirecting you to the dashboard.",
              errorMessage: "",
            });

            const decodedToken = jwtDecode(response.data.token);
            const tokenExpiryTime = decodedToken.exp * 1000;
            const currentTime = new Date().getTime();

            Cookies.set(
              "client_tkn__",
              CryptoJS.AES.encrypt(
                response.data.token,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_acn__",
              CryptoJS.AES.encrypt(
                response.data.accountno,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_eml__",
              CryptoJS.AES.encrypt(
                response.data.email,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_comp_nme__",
              CryptoJS.AES.encrypt(
                response.data.comp_name,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_user_type__",
              CryptoJS.AES.encrypt(
                response.data.user_type,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_parent_accountno__",
              CryptoJS.AES.encrypt(
                response.data.parent_accountno,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_name__",
              CryptoJS.AES.encrypt(
                response.data.name,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_phone__",
              CryptoJS.AES.encrypt(
                response.data.phone,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_adress__",
              CryptoJS.AES.encrypt(
                response.data.address,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_title__",
              CryptoJS.AES.encrypt(
                response.data.title,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_session_start__",
              CryptoJS.AES.encrypt(
                currentTime.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "client_session_expiry__",
              CryptoJS.AES.encrypt(
                tokenExpiryTime.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            // Set a lightweight session indicator on the parent domain so the
            // sharelink frontend (on a sibling subdomain) can detect the active session.
            try {
              const _hostname = window.location.hostname;
              const _parts = _hostname.split('.');
              const _parentDomain = _parts.length >= 2 ? '.' + _parts.slice(-2).join('.') : _hostname;
              Cookies.set('client_sl_session__', '1', { domain: _parentDomain, expires: 1 });
            } catch (_e) {}

            localStorage.removeItem("activeMenusClient");
            localStorage.removeItem("activeSubmenuItemClient");

            const {
              voicePermissionAdmin,
              integrationInfo,
              parentIntegration,
              form_external_link,
              unsignedAgreements,
              user_type,
            } = response.data;

            const hasChildInt =
              Array.isArray(integrationInfo) && integrationInfo.length > 0;
            const hasParentInt =
              Array.isArray(parentIntegration) && parentIntegration.length > 0;

            const baseChecks =
              voicePermissionAdmin === "Yes" &&
              unsignedAgreements === "No" &&
              typeof form_external_link === "string" &&
              form_external_link.trim() !== "" &&
              hasChildInt;

            let isDirectSSO = false;
            if (baseChecks) {
              if (user_type === "Super") {
                isDirectSSO =
                  integrationInfo[0].enable === "Yes" &&
                  integrationInfo[0].direct_sso === "Yes";
              } else if (user_type === "Sub") {
                isDirectSSO =
                  integrationInfo[0].enable === "Yes" &&
                  integrationInfo[0].direct_sso === "Yes" &&
                  hasParentInt &&
                  parentIntegration[0].enable === "Yes" &&
                  parentIntegration[0].direct_sso === "Yes";
              }
            }

            if (isDirectSSO) {
              const accountno = response.data.accountno;
              const email = response.data.email;
              const firstName = response.data.name;
              const compName = response.data.comp_name;
              const userType = response.data.user_type;
              const address = response.data.address || "";
              const title = response.data.title || "";
              const phone = response.data.phone || "";
              const country = response.data.country || "";
              const city = response.data.city || "";
              const zip = response.data.zip || "";
              const stateStr = response.data.state || "";
              const account_status =
                response.data.status === 200 ? "active" : "inactive";
              const status = account_status === "active" ? 1 : 0;
              const parent_accountno = response.data.parent_accountno || null;
              const serviceData = this.state.serviceArray_voicealerts || [];
              const return_url =
                APP_LIVE_URL + auth.getResellerRegToken() + "/client";

              const tokenData = {
                accountno,
                email,
                firstName,
                compName,
                userType,
                status,
                title,
                phone,
                address,
                city,
                state: stateStr,
                zip,
                country,
                password: "",
                serviceData,
                return_url,
                isDirectSSO,
                ...(userType === "Sub" ? { parent_accountno } : {}),
              };

              const tokenDataString = JSON.stringify(tokenData);
              const secretKey =
                process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
              const encryptedToken = this.pythonEncrypt(
                tokenDataString,
                secretKey
              );

              const finalUrl = form_external_link
                .replace(/\{{va_parameters\}}/g, encryptedToken)
                .replace(/\{{va_parameters_brand\}}/g, "");

              // Set cross-subdomain session indicator before leaving for SSO
              try {
                const _hostname = window.location.hostname;
                const _parts = _hostname.split('.');
                const _parentDomain = _parts.length >= 2 ? '.' + _parts.slice(-2).join('.') : _hostname;
                Cookies.set('client_sl_session__', '1', { domain: _parentDomain, expires: 1 });
              } catch (_e) {}

              window.location.replace(finalUrl);
              return;
            }

            setTimeout(function () {
              try {
                const pendingOrderRefStr = localStorage.getItem('pendingOrderRef');
                if (pendingOrderRefStr) {
                  const pendingOrderRef = JSON.parse(pendingOrderRefStr);
                  const TWO_HOURS = 7200000;
                  if (pendingOrderRef.service_id && (Date.now() - pendingOrderRef.timestamp) < TWO_HOURS) {
                    localStorage.removeItem('pendingOrderRef');
                    const resellerUrl = auth.getResellerRegToken();
                    const base = resellerUrl ? '/' + resellerUrl : '';
                    if (pendingOrderRef.form_accountno && pendingOrderRef.form_accountno !== "") {
                      window.location.replace(`${base}/client/client_form_submit/${pendingOrderRef.form_accountno}/${crypto.randomUUID()}/${pendingOrderRef.service_id}`);
                    } else {
                      const qty = pendingOrderRef.product_quantity || '1';
                      const tempOrderNo = Math.floor(100000 + Math.random() * 900000);
                      window.location.replace(`${base}/client/EditSalesOrder/${tempOrderNo}/${pendingOrderRef.service_id}/?qty=${qty}`);
                    }
                    return;
                  }
                  localStorage.removeItem('pendingOrderRef');
                }
              } catch (e) {
                localStorage.removeItem('pendingOrderRef');
              }
              window.location.replace("/client/dashboard");
            }, 1000);
          } else {
            if (this._isMounted) {
              this.setState({
                successMessage: "",
                errorMessage:
                  "There was some error while processing the request. Please try again!",
              });
            }
          }
        });
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          errorMessage: "",
          successMessage: "",
          show_form: false,
          disabled: false,
          pageError:
            "Please enter the valid URL or contact admin for more details",
        });
      }
      // console.log("catch : ", error);
    }
  };

  render() {
    if (!this.state.isLogoutAction) {
      if (auth.isLogin() === true) {
        return <Redirect to="/dashboard" />;
      }
      if (auth.isAdminLogin() === true) {
        return <Redirect to="/admin_dashboard" />;
      }
      if (auth.isClientLogin() === true) {
        // Check if there is a pending order reference from a sharelink Order Now click
        try {
          const pendingOrderRefStr = localStorage.getItem('pendingOrderRef');
          if (pendingOrderRefStr) {
            const pendingOrderRef = JSON.parse(pendingOrderRefStr);
            const TWO_HOURS = 7200000;
            if (pendingOrderRef.service_id && (Date.now() - pendingOrderRef.timestamp) < TWO_HOURS) {
              localStorage.removeItem('pendingOrderRef');
              const resellerUrl = auth.getResellerRegToken();
              const base = resellerUrl ? '/' + resellerUrl : '';
              if (pendingOrderRef.form_accountno && pendingOrderRef.form_accountno !== "") {
                return (
                  <Redirect to={`${base}/client/client_form_submit/${pendingOrderRef.form_accountno}/${crypto.randomUUID()}/${pendingOrderRef.service_id}`} />
                );
              }
              const qty = pendingOrderRef.product_quantity || '1';
              const tempOrderNo = Math.floor(100000 + Math.random() * 900000);
              return (
                <Redirect to={`${base}/client/EditSalesOrder/${tempOrderNo}/${pendingOrderRef.service_id}/?qty=${qty}`} />
              );
            }
            localStorage.removeItem('pendingOrderRef');
          }
        } catch (e) {
          localStorage.removeItem('pendingOrderRef');
        }
        return (
          <Redirect
            to={"/" + auth.getResellerRegToken() + "/client/dashboard"}
          />
        );
      }
    }

    return (
      <div className="nk-body npc-crypto ui-clean pg-auth">
        <div className="nk-app-root">
          <div className="nk-split nk-split-page nk-split-md">
            <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container">
              <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                <a
                  href="#"
                  className="toggle btn-white btn btn-icon btn-light"
                  data-target="athPromo"
                >
                  <em className="icon ni ni-info"></em>
                </a>
              </div>
              <div
                className="nk-block nk-block-middle nk-auth-body"
                style={{ marginRight: "auto" }}
              >
                <div className="brand-logo pb-5 text-center">
                  {auth.getResellerLogo() && auth.getResellerLogo() !== "" ? (
                    <a href="/" className="logo-link">
                      <img
                        className="logo-light logo-img logo-img-lg"
                        src={auth.getResellerLogo()}
                        alt="logo"
                      />
                      <img
                        className="logo-dark logo-img logo-img-lg"
                        src={auth.getResellerLogo()}
                        alt="logo-dark"
                      />
                    </a>
                  ) : (
                    <a href="/" className="logo-link">
                      <img
                        className="logo-light logo-img logo-img-lg"
                        src={LOGO}
                        alt="logo"
                      />
                      <img
                        className="logo-dark logo-img logo-img-lg"
                        src={LOGO}
                        alt="logo-dark"
                      />
                    </a>
                  )}
                </div>

                <div className="nk-block-head">
                  <div className="nk-block-head-content">
                    <h5 className="nk-block-title">Sign-In</h5>

                    <div className="nk-block-des">
                      <p>Use your verified email and password.</p>

                      {this.state.errorMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {this.state.successMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />
                    </div>
                  </div>
                </div>
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      href="#tabItem5"
                    >
                      <em className="icon ni ni-signin"></em>
                      <span>Client Login</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href={`${this.state.res_url}/agent/login`}
                    >
                      <em className="icon ni ni-signin"></em>
                      <span>{`${localization.authPage.label_single} Login`}</span>
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane active" id="tabItem5">
                    {this.state.pageError !== "" ? (
                      <div className="example-alert">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p>{this.state.pageError}</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {this.state.tableLoaderSimple === true ? (
                          tableLoaderSimple()
                        ) : (
                          <form
                            autoComplete="off"
                            method="post"
                            className="loginForm"
                            onSubmit={this.formSubmitClient}
                          >
                            <div className="form-group">
                              <div className="form-label-group">
                                <label
                                  className="form-label"
                                  htmlFor="default-01"
                                >
                                  Email
                                </label>
                              </div>
                              <input
                                type="email"
                                className={
                                  "form-control form-control-lg " +
                                  this.state.errorEmail
                                }
                                id="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.handleChange}
                                placeholder="Enter your email address"
                              />
                            </div>
                            <div className="form-group">
                              <div className="form-label-group">
                                <label
                                  className="form-label"
                                  htmlFor="password"
                                >
                                  Password
                                </label>
                                <a
                                  className="link link-primary link-sm"
                                  tabIndex="-1"
                                  href={`/${this.state.res_url}/client/forgot`}
                                  style={{ color: "#006393" }}
                                >
                                  Forgot Password?
                                </a>
                              </div>
                              <div className="form-control-wrap">
                                <button
                                  type="button"
                                  tabIndex="-1"
                                  className="form-icon form-icon-right passcode-switch"
                                  onClick={this.togglePassword}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: "0", // Optional: Set padding to zero if there's unwanted spacing
                                    cursor: "pointer",
                                    outline: "none", // Remove outline when button is clicked
                                  }}
                                >
                                  <em
                                    className={`passcode-icon icon-show icon ni ${
                                      this.state.passwordShown
                                        ? "ni-eye-off"
                                        : "ni-eye"
                                    }`}
                                  ></em>
                                </button>
                                <input
                                  type={
                                    this.state.passwordShown
                                      ? "text"
                                      : "password"
                                  }
                                  className={`form-control form-control-lg ${this.state.errorPass}`}
                                  id="password"
                                  name="password"
                                  onChange={this.handleChange}
                                  value={this.state.password}
                                  placeholder="Enter your password"
                                />
                              </div>
                            </div>
                            <ReCAPTCHA
                              sitekey={this.site_key}
                              onChange={this.handleCaptchaChange}
                              style={{ padding: "0px 0px 15px" }}
                            />
                            <div className="form-group">
                              <button
                                className="btn btn-lg btn-block"
                                disabled={this.state.disabled}
                                type="submit"
                                style={{
                                  backgroundColor: THEME_COLOR,
                                  color: "white",
                                }}
                              >
                                Sign in
                              </button>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              <hr
                                style={{
                                  flex: 1,
                                  border: "none",
                                  borderBottom: "1px solid #ccc",
                                }}
                              />
                              <span style={{ padding: "0 10px" }}>OR</span>
                              <hr
                                style={{
                                  flex: 1,
                                  border: "none",
                                  borderBottom: "1px solid #ccc",
                                }}
                              />
                            </div>
                            <div className="my-3">
                              <div className="googleLoginBtn-large">
                                <GoogleLogin
                                  onSuccess={this.handleGoogleSuccess}
                                  onError={() => {
                                    // console.log("Login Failed");
                                  }}
                                  size="large"
                                  theme="outline"
                                  text="signup_with"
                                  width="380px"
                                  logo_alignment="center"
                                />
                              </div>
                              <div className="googleLoginBtn-small">
                                <GoogleLogin
                                  onSuccess={this.handleGoogleSuccess}
                                  onError={() => {
                                    // console.log("Login Failed");
                                  }}
                                  size="large"
                                  theme="outline"
                                  text="signup_with"
                                  width="335px"
                                  logo_alignment="center"
                                />
                              </div>
                            </div>
                          </form>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="form-note-s2 pt-4">
                  New on our platform?
                  <a
                    href={`${APP_URL}client/register/${this.state.signup_hash}`}
                  >
                    &nbsp;Create an account{" "}
                  </a>
                </div>
              </div>
              <div className="nk-block nk-auth-footer">
                <div className="text-center">
                  <p>{FOOTER_SIGNATURE}</p>
                  <div>
                    <a
                      href={`${APP_URL}pages/privacyPolicy`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      Privacy Policy
                    </a>
                    <span className="mx-2">|</span>
                    <a
                      href={`${APP_URL}pages/terms-of-service`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      Terms of Service
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right"
              data-content="athPromo"
              data-toggle-screen="lg"
              data-toggle-overlay="true"
            >
              <div className="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                <div
                  className="slider-init"
                  data-slick='{"dots":false, "arrows":false}'
                >
                  <div className="slider-item">
                    <div className="nk-feature nk-feature-center">
                      <div className="nk-feature-img">
                        <img className="round" src={PROMO_New} alt="" />
                      </div>
                      <div className="nk-feature-content py-4 p-sm-5">
                        <h4>{`${
                          auth.getResellerRegTitle() || ""
                        } Client Portal`}</h4>
                        <p>{localization.clientRegistrationPage.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.appVersion && (
                  <div className="text-center mt-3">
                    <small style={{ color: "#8094ae" }}>
                      Version {this.state.appVersion}
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
